export class EnumApiComsvr {}
